import { Injectable } from '@angular/core';
import { Video } from '../_model/video/video';
import { DnMedia, DnMediaSource } from '../_model/dn-media';
import { CategoryService } from '../_service/category/category.service';
import { environment } from '../../environments/environment';
import { Utility } from '../_service/utility';
@Injectable()
export class VideoTransFormer {
    isAdult = environment.cinema === 2;

    constructor(
        private _categoryService: CategoryService,
        
        private _utility:Utility
    ) {
    }
    private getData(data: any): Video {
        return <Video>Object.assign({}, data);
    }

    transformFromNews(item): Video {
        item.userData = {
            viewCount: item.views,
            like: item.good,
            comments: item.comments,
            dislike: item.bad,
            favorites: item.favoriteCount,
        };
        item.published = item.addTime;
        item.key = item.contxt || item.key;
        item.image = item.image || item.imgPath;
        return this.getData(item);
    }
    transformFromList(item): Video {
        let tags = [];
        if (item.label) {
            tags = item.label.trim().split(' ');
        } else if (item.videoType) {
            tags = item.videoType.trim().split(' ');
        }
        if (tags.length === 1) {
            tags = tags[0].trim().split(',');
        }
        tags = tags.filter(t => t !== '');

        const video: Video = this.getData({
            copyrightinfo: "",
            filtergold: 10,
            lastKey: item.lastKey,
            id: item.id,
            cid: item.cid,
            key: item.key || item.contxt || '',
            title: item.title,
            category: this._categoryService.getCategoryByTitle(item.atypeName),
            summary: item.summary ? item.summary : '',
            image: item.image || this._utility.staticResource(item.imgPath.replace('s.', '.')),
            link: item.contxt,
            recommended: item.isIndex,
            favorites: item.favorites ? item.favorites : 0,
            newItems: item.newItems ? item.newItems : 0,
            lastUpdate: item.lastName,
            lastName: item.lastName,
            updates: item.isShowTodayNum ? item.todayNum : 0,
            updateSchedule: '',
            updated: item.addTime,
            created: '',
            published: item.postTime ? item.postTime.split('-')[0] : item.addTime ? item.addTime : "",
            genre: item.cid,
            rating: item.rating,
            region: item.regional,
            language: item.lang,
            tags: tags,
            mosaic: false,
            playlist: item.languagesPlayList?.playList || {},
            directors: item.directed ? item.directed.split(' / ') : [],
            directed: item.directed ? item.directed : '',
            updateweekly: item.updateweekly ? item.updateweekly : '',
            actors: item.starring ? item.starring.split(',').filter(s => s !== '') : [],
            lastUpdatedItem: item.lastName,
            recApiUrl: '',
            languages: [],
            isFree: true,
            inProgress: item.isSerial,
            isFilm:  item.isFilm,///是否为电影
            isDocumentry:item.isDocumentry,///是否为纪录片
            userData: {
                viewCount: item.view || item.hot || 0,
                comments: item.comments,
                favorites: item.favoriteCount,
                shared: 0,
                like: item.dd,
                dislike: item.dc,
                // rate: item.rating ? Number(item.rating).toFixed(1) : null,
                rate: item.pingFen ? (Number(item.pingFen) / 10).toFixed(1) : null,
                popular: 0,
                trending: 0,
            },
            score: item.score,
            userBehaviors: {
                favorite: false,
                favoriteAt: '',
                favoriteId: '',
                like: false,
                dislike: false,
                lastWatch: '',
                watchHistoryId: undefined,
                lastWatchedMedia: {
                    length: 0,
                    playedTime: 0,
                    playTimeLeft: 0
                }
            },
            videoLength: item.lastseconds ? item.lastseconds.split('.')[0].split(':').slice(1).join(':') : '',
            favoriteCount: item.favoriteCount,
            year: item.year,
            regional: item.regional,
            lang: item.lang,
            videoType: item.videoType,
            starring: item.starring,
            contxt: item.shortDes,
            hot: item.hot,
            cidMapper: item.cidMapper,
            videoClassID: item.videoClassID ? item.videoClassID : '',
            uploaderName: item.uploadedby ? item.uploadedby : item.nickName ? item.nickName : '',
            uploaderKey: item.userKey ? item.userKey : '',
            avatar: item.avatar ? item.avatar : '',
            add_Date : item.add_Date ? item.add_Date : '',
            videoSumTimes: item.videoSumTimes ? item.videoSumTimes : '',
            vipResource: item.vipResource ? item.vipResource : '',
            isOfficalUP: item.isOfficalUP ? item.isOfficalUP : false,
        });


        video.tags = tags;
        return video;
    }

    transformFromRankedList(item): Video {
        const video: Video = this.getData({

            cid: item.cid,
            cidMapperArray: item.cidMapper.split(','),
            key: item.link,
            title: item.title,
            link: item.link,
            updates: item.isShowTodayNum ? item.todayNum : 0,
            published: item.year,
            genre: item.cid,
            region: item.regional,
            language: item.language,
            rating: item.rating

        });
        return video;
    }

    transformFromVideoService(item) {
        let video: Video 
        if(item ==null)
        {
            video = this.getData({});
        }
        else
        {
            video = this.getData({
                watchTimeout:item.watchTimeout,
                extraList:item.extraList,
                copyrightinfo: item.copyRightInfo,
                taxis: item.taxis,
                id: item.id,
                cid: item.cid,
                cidMapper: item.cidMapper ? item.cidMapper : '',
                key: item.key,
                title: item.title,
                category: this._categoryService.getCategoryByTitle(item.channel),
                summary: item.contxt,
                keywords: item.keyWord,
                isMediaTitleVisible: item.isMediaTitleVisible,///是否显示视频标题
                image: this._utility.staticResource(item.imgPath.replace('s.', '.')),
                link: item.contxt,
                recommended: false,
                favorites: item.favrateNumber,
                newItems: 0,
                lastUpdate: item.lastName,
                lastName: item.lastName,
                updates: item.isShowTodayNum ? item.todayNum : 0,
                updateSchedule: item.updateweekly,
                created: item.add_date,
                published: item.post_Year,
                genre: item.videoType,
                region: item.regional,
                language: item.language,
                tags: item.labels,
                mosaic: item.masaike,
                filtergold: item.filterGold,
                isFree: item.isFree,
                inProgress: item.isSerial,
                externalLink: item.link,
                publisher: item.publisher,
                commentStatus: item.commentStatus,
                publishNavKey: item.publishNavKey,
                playlist: {
                },
                unlockGold: item.unlockGold,
                directors: item.directors,// item.vl.director == null || item.vl.director === '' ? [] : item.vl.director.split(','),
                actors: item.stars,
                lastUpdatedItem: '',
                recApiUrl: item.playRecordURL,
                languages: item.languageList,
                serialCount: item.serialCount ? item.serialCount : 0,
                userData: {
                    viewCount: item.view,
                    comments: item.comments,
                    favorites: item.favoriteCount,
                    shared: item.shareCount,
                    like: item.good,
                    dislike: item.bad,
                    rate: Math.floor(item.pinfenRate * 100) / 10,
                    popular: item.renqiRate,
                    trending: 0,
                },
                score: item.score,
                userBehaviors: {
                    favorite: item.isVideoFavrited,
                    favoriteAt: '',
                    favoriteId: '',
                    like: item.likeStatus == 1,
                    dislike: item.likeStatus == 2,
                    lastWatch: '',
                    watchHistoryId: undefined,
                    lastWatchedMedia: {
                        length: 0,
                        playedTime: 0,
                        playTimeLeft: 0
                    }
                },
                isWide:item.isWide
            });
            if (video.languages && video.languages.length) {
                if (video.languages[0].title === video.language) {
                    video.languages.unshift({
                        title: video.language,
                        link: video.key
                    });
                } else {
                    video.languages.unshift({
                        title: video.language,
                        link: video.key
                    });
                }
                video.languages = video.languages.sort((a, b) => (a.title > b.title) ? 1 : -1);
            }
        }
       
        return video;
    }

    transformFromFavoriteList(item): Video {
        const video: Video = this.getData({
            copyrightinfo: "",
            id: item.videoID,
            cid: item.cid,
            key: item.secretVID,
            title: item.title,
            category: this._categoryService.getCategoryByTitle(item.atypeName),
            summary: '',
            image: item.imgPath ? this._utility.staticResource(item.imgPath.replace('s.', '.')) : '',
            link: item.secretVID,
            recommended: false,
            favorites: 0,
            newItems: 0,
            lastUpdate: item.updateTime,
            updates: item.todayUpdateNumber,
            updateSchedule: '',
            created: '',
            published: item.year,
            genre: item.className,
            region: item.regional,
            language: item.lang,
            filtergold: 10,
            tags: [],
            mosaic: false,
            playlist: {},
            directors: item.director ? item.director.split(',') : '',
            actors: item.starring ? item.starring.split(',') : '',
            lastUpdatedItem: item.lastName,
            recApiUrl: '',
            languages: [],
            isFree: true,
            inProgress: item.isSerial,
            userData: {
                viewCount: item.hot,
                comments: item.commentNumber,
                favorites: item.favrateNumber,
                shared: 0,
                like: item.dd,
                dislike: item.dc,
                rate: 0,
                popular: 0,
                trending: 0,
            },
            userBehaviors: {
                favorite: true,
                favoriteAt: item.addTime,
                favoriteId: item.favoriteID,
                like: false,
                dislike: false,
                lastWatch: '',
                watchHistoryId: undefined,
                lastWatchedMedia: {
                    length: 0,
                    playedTime: 0,
                    playTimeLeft: 0
                }
            },
            // 收藏 相册+动态
            ablumID: item?.ablumID,
            addTime: item?.addTime,
            commentNumber: item?.commentNumber,
            favrateNumber: item?.favrateNumber,
            likeNumber: item?.dd,
            viewNumber: item?.hot,
            label: item?.label,
            headImg: item?.headImg,
            nickName: item?.nickName,
            photoList: item?.photoList,
            photoAlbumDetailsList: item?.photoAlbumDetailsList,
            sumPhotoCount: item?.sumPhotoCount,
            userKey: item?.userKey,
            gid: item?.gid,
            isUp: item?.isUp,
            contxt: item?.description,
            photoType: item?.photoType,
        });
        return video;
    }
    /*
    ** Do not Modify
    */
    transformFromWatchHistoryList(item): Video {
        var link = item.link;//.split('?id=')[1];
        var list = link.split("?id=");
        if (list.length > 0 && !!list[1]) {
            link = list[1];
        }
        const video: Video = this.getData({
            copyrightinfo: "",
            id: item.vid,
            cid: item.cid,
            key: link,
            title: item.title,
            category: '',
            summary: '',
            image: item.imgPath,
            link: link,
            recommended: false,
            favorites: 0,
            newItems: 0,
            lastUpdate: '',
            updates: item.isShowTodayNum ? item.todayNum : 0,
            updateSchedule: '',
            created: '',
            published: item.postYear,
            genre: item.videoType,
            region: item.region,
            language: item.lang,
            tags: [],
            mosaic: false,
            playlist: {},
            directors: [],
            actors: [],
            lastUpdatedItem: item.cid.startsWith('0,1,3') ? '-' : item.lastTitle ? item.lastTitle : '',
            recApiUrl: '',
            languages: [],
            filtergold: 10,
            isFree: true,
            inProgress: false,
            userData: {
                viewCount: 0,
                comments: 0,
                favorites: 0,
                shared: 0,
                like: 0,
                dislike: 0,
                rate: 0,
                popular: 0,
                trending: 0,
            },
            userBehaviors: {
                favorite: false,
                favoriteAt: '',
                favoriteId: '',
                like: false,
                dislike: false,
                lastWatch: item.updateTimeStr,
                lastWatchTime: item.updateTime,
                watchHistoryId: item.vid,
                lastWatchedMedia: {
                    length: item.totalTime,
                    playedTime: item.playTime,
                    playTimeLeft: Number(item.leftTime) ? Number(item.leftTime) : 0
                }
            },
            uploaderName: item.nickName,
            uploaderUid: item.uploaderUid,
            uploaderKey: item.uploaderKey,
        });
        return video;
    }

    transformFromGetHotVideoTop(item): Video {

        const video: Video = this.getData({
            copyrightinfo: "",
            id: '',
            cid: item.cid,
            key: item.link,
            title: item.title,
            category: '',
            summary: '',
            image: '',
            link: '',
            recommended: false,
            favorites: item.favoritenum,
            newItems: item.updateNumber,
            lastUpdate: '',
            updates: item.updateNumber,
            updateSchedule: '',
            created: '',
            published: '',
            genre: '',
            region: '',
            language: '',
            tags: [],
            mosaic: false,
            playlist: {},
            directors: [],
            actors: [],
            lastUpdatedItem: '',
            recApiUrl: '',
            languages: [],
            filtergold: 10,
            isFree: true,
            inProgress: false,
            userData: {
                viewCount: 0,
                comments: 0,
                favorites: item.favoriteNum,
                shared: 0,
                like: 0,
                dislike: 0,
                rate: item.pinFenValue,
                popular: 0,
                trending: item.rankStatus,
            },
            userBehaviors: {
                favorite: false,
                favoriteAt: undefined,
                favoriteId: undefined,
                like: false,
                dislike: false,
                lastWatch: undefined,
                watchHistoryId: undefined,
                lastWatchedMedia: {
                    length: 0,
                    playedTime: 0,
                    playTimeLeft: 0
                }
            }
        });
        return video;
    }

    convertVideoResolution(value) {
        switch (value) {
            case '枪版': {
                return 'TS';
            }
            case 'DVD': {
                return '480P';
            }
            case '1080p': {
                return '1080P';
            }
            case '超清': {
                return '720P';
            }
            default: {
                return null;
            }
        }
    }



}
